var _excluded = ["selectedOption", "placeholder", "size", "isDisabled", "isReadOnly", "isViewMode", "isInvalid", "isLoading", "isFocused", "paddingRight", "valueRenderer"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Input } from '@chakra-ui/react';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Text } from '../../../dataDisplay';
import { Box } from '../../../internal';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * This component is used to display the selected option or the placeholder inside the trigger.
 */
export var TriggerValue = _ref => {
  var _valueRenderer;

  var {
    selectedOption,
    placeholder,
    size,
    isDisabled,
    isReadOnly,
    isViewMode,
    isInvalid,
    isLoading,
    isFocused,
    paddingRight,
    valueRenderer
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('SelectNew', {
    hasCustomValue: Boolean(valueRenderer)
  });
  return /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
    "data-component": "SelectNew.TriggerValue",
    as: "div",
    className: size,
    sx: styles['triggerValue'],
    "data-invalid": isInvalid || undefined,
    "data-focus": isFocused || undefined,
    "data-readonly": isReadOnly || isLoading || isViewMode || undefined,
    "data-loading": isLoading || undefined,
    "data-view-mode": isViewMode || undefined,
    "aria-disabled": isDisabled || undefined,
    "aria-hidden": true,
    paddingRight: paddingRight
  }, otherProps), {}, {
    children: selectedOption ? (_valueRenderer = valueRenderer === null || valueRenderer === void 0 ? void 0 : valueRenderer(selectedOption)) !== null && _valueRenderer !== void 0 ? _valueRenderer : /*#__PURE__*/_jsx(Text, {
      textStyle: "inline",
      color: "inherit",
      shouldSupportEllipsis: true,
      children: selectedOption.label
    }) : /*#__PURE__*/_jsx(Box, {
      __css: styles['placeholder'],
      "data-disabled": isDisabled || undefined,
      children: /*#__PURE__*/_jsx(Text, {
        textStyle: "inline",
        color: "inherit",
        shouldSupportEllipsis: true,
        children: placeholder
      })
    })
  }));
};
TriggerValue.displayName = 'SelectNew.TriggerValue';
//# sourceMappingURL=TriggerValue.js.map